import routes from "./router/routes"
import Vue from "vue"
import Router from "vue-router"

export function authModule({ router }: { router: Router; eventBus: Vue }) {
  for (const route of routes) router.addRoute(route)
}
